import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from '../assets/marketingDashboard.module.css';
import { marketingService } from '../services/marketingService';
import Loader from '../components/Loader';

const MarketingDashboard = () => {
  const [statistics, setStatistics] = useState({
    guardians: 0,
    placedGuardians: 0,
    clientContacts: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadMarketingData();
  }, []);

  const loadMarketingData = async () => {
    try {
      setLoading(true);
      const data = await marketingService.getMarketingDashboardData();
      console.log('📊 [MARKETING] Dashboard data loaded:', data);
      
      if (data.success && data.statistics) {
        setStatistics(data.statistics);
        console.log('📊 [MARKETING] Statistics updated:', data.statistics);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Error loading marketing data:', error);
      setError(error.message);
      toast.error('Failed to load marketing data');
    } finally {
      setLoading(false);
    }
  };

  const handleExportGuardiansEmails = async () => {
    try {
      await marketingService.exportGuardiansEmails();
      toast.success('Guardians emails exported successfully!');
    } catch (error) {
      console.error('Error exporting guardians emails:', error);
      toast.error('Failed to export guardians emails');
    }
  };

  const handleExportClientContactsEmails = async () => {
    try {
      await marketingService.exportClientContactsEmails();
      toast.success('Client contacts emails exported successfully!');
    } catch (error) {
      console.error('Error exporting client contacts emails:', error);
      toast.error('Failed to export client contacts emails');
    }
  };

  if (loading) return <Loader />;
  if (error) return <div className={styles.errorContainer}>Error: {error}</div>;

  return (
    <div style={{ backgroundColor: '#f0f4f8', minHeight: '100vh', width: '100%' }}>
      <div className={styles.container}>
        {/* Breadcrumbs */}
        <div className={styles.breadcrumbContainer}>
          <nav aria-label="breadcrumb">
            <ol className={styles.breadcrumb}>
              <li className={styles.breadcrumbItem}>
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>
                Marketing
              </li>
            </ol>
          </nav>
        </div>

        <div className={styles.row}>
          {/* Guardians Dashbox */}
          <div className={styles.colMd4}>
            <div className={styles.dashbox}>
              <div className={styles.dashboxHeading}>
                <h3>Guardians</h3>
              </div>
              <div className={styles.dashboxBody}>
                <button
                  className={`${styles.btn} ${styles.btnLarge} ${styles.btnDefault}`}
                  onClick={handleExportGuardiansEmails}
                >
                  Export guardians' emails
                </button>
              </div>
              <div className={styles.dashboxFooter}>
                <div>
                  <span className={styles.dashboxFooterLabel}>All guardians:</span>
                  <span className={styles.dashboxBadge}>{statistics.guardians}</span>
                </div>
                <div>
                  <span className={styles.dashboxFooterLabel}>All placed guardians number:</span>
                  <span className={styles.dashboxBadge}>{statistics.placedGuardians}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Clients Dashbox */}
          <div className={styles.colMd4}>
            <div className={styles.dashbox}>
              <div className={styles.dashboxHeading}>
                <h3>Clients</h3>
              </div>
              <div className={styles.dashboxBody}>
                <button
                  className={`${styles.btn} ${styles.btnLarge} ${styles.btnDefault}`}
                  onClick={handleExportClientContactsEmails}
                >
                  Export client contacts' emails
                </button>
              </div>
              <div className={styles.dashboxFooter}>
                <div>
                  <span className={styles.dashboxFooterLabel}>All client contacts:</span>
                  <span className={styles.dashboxBadge}>{statistics.clientContacts}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingDashboard; 